const transformPriceDto = dto => ({
  amount: dto.amount,
  currencyCode: dto.currency_code
});

export const transformStoryDto = story => ({
  id: story.id,
  thumbnailUrl: story.thumbnail_url,
  videoUrl: story.video_url,
  item: {
    id: story.item.id,
    url: story.item.url,
    brand: story.item.brand,
    size: story.item.size,
    price: {
      base: transformPriceDto(story.item.price.base),
      total: transformPriceDto(story.item.price.total),
      serviceFee: transformPriceDto(story.item.price.service_fee)
    }
  },
  user: {
    photoUrl: story.user.photo_url,
    login: story.user.login,
    profileUrl: story.user.profile_url,
    feedback: story.user.feedback,
    isBusiness: story.user.is_business
  }
});
export const transformStoryDtos = stories => stories.map(story => transformStoryDto(story));